/* Publish by EComposer at 2026-09-26 10:00:55*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4x8aimqmuyh"]=  window.__ectimmers["ecom-4x8aimqmuyh"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-4x8aimqmuyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4x8aimqmuyh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3njm7lmii0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3njm7lmii0s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kgs2h37c92').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kgs2h37c92', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r35aa128ug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r35aa128ug', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pdnokd0hrof').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdnokd0hrof', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9h7g13tvj0c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9h7g13tvj0c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cf02j60titp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cf02j60titp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w2w7gqtdmcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w2w7gqtdmcj', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}